import { Calendar, CheckCircle, Circle, Clock } from 'lucide-react';
import { Task } from '@/types/meeting';

interface TaskListProps {
  tasks: Task[];
  onUpdateTask: (taskId: string, updates: Partial<Task>) => void;
}

export function TaskList({ tasks, onUpdateTask }: TaskListProps) {
  const getStatusIcon = (status: Task['status']) => {
    switch (status) {
      case 'COMPLETED':
        return <CheckCircle className="w-5 h-5 text-green-500" />;
      case 'IN_PROGRESS':
        return <Clock className="w-5 h-5 text-yellow-500" />;
      default:
        return <Circle className="w-5 h-5 text-gray-300" />;
    }
  };

  const formatDate = (date: Date) => {
    return new Intl.DateTimeFormat('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    }).format(date);
  };

  return (
    <div className="space-y-4">
      {tasks.map((task) => (
        <div
          key={task.id}
          className="flex items-start space-x-4 p-4 bg-white rounded-lg border border-gray-200"
        >
          <button
            onClick={() =>
              onUpdateTask(task.id, {
                status:
                  task.status === 'COMPLETED'
                    ? 'PENDING'
                    : task.status === 'PENDING'
                    ? 'IN_PROGRESS'
                    : 'COMPLETED',
              })
            }
            className="mt-1"
          >
            {getStatusIcon(task.status)}
          </button>

          <div className="flex-grow">
            <h4 className="text-sm font-medium text-gray-900">{task.title}</h4>
            <p className="mt-1 text-sm text-gray-500">{task.description}</p>
            
            <div className="mt-2 flex items-center space-x-4">
              <div className="flex items-center">
                <Calendar className="w-4 h-4 text-gray-400 mr-1" />
                <span className="text-sm text-gray-500">
                  Due {formatDate(task.dueDate)}
                </span>
              </div>

              <div className="flex items-center">
                <img
                  src={task.assignee.avatar || `https://ui-avatars.com/api/?name=${task.assignee.name}`}
                  alt={task.assignee.name}
                  className="w-6 h-6 rounded-full mr-2"
                />
                <span className="text-sm text-gray-500">{task.assignee.name}</span>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}